<payee-popup
  [heading]="'CASE_FORM.FORMS.SUMMARY.TRANSFER_DIALOG.TITLE' | translate"
  [description]="'CASE_FORM.FORMS.SUMMARY.TRANSFER_DIALOG.DESCRIPTION' | translate"
>
  <form
    data-testid="transfer-dialog"
    [formGroup]="form"
  >
    <payee-form-field width="max">
      <span payee-label>
        {{ "CASE_FORM.FORMS.SUMMARY.TRANSFER_DIALOG.AMOUNT_LABEL" | translate }}
      </span>
      <span
        payee-suffix
        style="margin-right: 30px"
      >
        {{ data.currency_iso }}
      </span>
      <payee-copy-form-field formControlName="transfer_amount"></payee-copy-form-field>
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>
        {{ "CASE_FORM.FORMS.SUMMARY.TRANSFER_DIALOG.BENEFICIARY_LABEL" | translate }}
      </span>
      <payee-copy-form-field formControlName="account_holder_name"></payee-copy-form-field>
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>
        {{ "CASE_FORM.FORMS.SUMMARY.TRANSFER_DIALOG.ACCOUNT_NUMBER_LABEL" | translate }}
      </span>
      <payee-copy-form-field formControlName="account_number"></payee-copy-form-field>
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>
        {{ "CASE_FORM.FORMS.SUMMARY.TRANSFER_DIALOG.REFERENCE_LABEL" | translate }}
      </span>
      <payee-copy-form-field formControlName="reference"></payee-copy-form-field>
    </payee-form-field>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      data-testid="transfer-dialog-continue"
      mat-dialog-close
    >
      <div class="close-button-content">
        <span>
          {{ "CASE_FORM.FORMS.SUMMARY.TRANSFER_DIALOG.BUTTON_LABEL" | translate }}
        </span>
        <payee-icon name="arrow-right-white"></payee-icon>
      </div>
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate></ng-template>
</payee-popup>
